import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Add = (props) => (
  <Icon viewBox="0 0 40.88 40.88" {...props}>
    <g>
      <defs/>
      <title>icon 2</title>
      <path d="M266.5 463a20.44 20.44 0 1 0 20.44 20.44A20.46 20.46 0 0 0 266.5 463zm0 39.88a19.44 19.44 0 1 1 19.44-19.44 19.46 19.46 0 0 1-19.44 19.44z"
        transform="translate(-246.05 -462.99)" className="cls-1" />
      <path d="M20.95 13.01h-1V20h-7v1h7v7h1v-7h7v-1h-7v-6.99z" className="cls-1" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Add;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Add.js